export class ProductsModel{
    id: string;
    prod: string;
    prodName: string;
    prodMns: string;
    prodLgf: string;
    prodMgm: string;
    income: string;

}